import React from 'react';
import asyncComponent from '../../../util/asyncComponent';

import PrivateRoute from './PrivateRoute';
import { Route, Switch } from 'react-router-dom';

const Dashboards = asyncComponent(() => import('../dashboards'));
const DashMetasEquipe = asyncComponent(() =>
  import('../dashboards/Metas/Equipe/MetasEquipe')
);
const DashMetasEmpresa = asyncComponent(() =>
  import('../dashboards/Metas/Empresa/MetasEmpresa')
);
const DashMetasNegociador = asyncComponent(() =>
  import('../dashboards/Metas/Negociador/MetasNegociador')
);
const DashMetasConfiguracoes = asyncComponent(() =>
  import('../dashboards/Metas/Configuracoes/ListaConfiguracoes')
);

export default function DashboardRoutes({ match }) {
  return (
    <>
      <Switch>
        <PrivateRoute
          path={`${match.url}/dash/metas/empresa`}
          component={DashMetasEmpresa}
          codigo="dash.metas.empresa"
        />
        <PrivateRoute
          path={`${match.url}/dash/metas/equipe`}
          component={DashMetasEquipe}
          codigo="dash.metas.equipe"
        />
        <PrivateRoute
          path={`${match.url}/dash/metas/negociador`}
          component={DashMetasNegociador}
          codigo="dash.metas.individual"
        />
        <PrivateRoute
          path={`${match.url}/dash/metas/config`}
          component={DashMetasConfiguracoes}
          codigo="dash.metas.config"
        />

        <Route path={`${match.url}/dash/inicio`} component={Dashboards} />
        <Route exact path={`${match.url}/dash`} component={Dashboards} />
      </Switch>
    </>
  );
}
